import { render, staticRenderFns } from "./marketVideo.vue?vue&type=template&id=fc6319e2&scoped=true"
import script from "./marketVideo.vue?vue&type=script&lang=js"
export * from "./marketVideo.vue?vue&type=script&lang=js"
import style0 from "./marketVideo.vue?vue&type=style&index=0&id=fc6319e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6319e2",
  null
  
)

export default component.exports